module.exports = __webpack_public_path__ + "static/media/Implicit_Grant.bcf4da6a.png";